const REPORT_TYPES=['FEEDBACK','BUG','TRANSLATION'];export default REPORT_TYPES;